


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { SquareAccountAddOrUpdateViewModel } from '@/models/payment/squareAccount';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class EditVehicleWholesaleAccountPage extends Base {
    public vm: SquareAccountAddOrUpdateViewModel = new SquareAccountAddOrUpdateViewModel();
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public disableSubmitButton: boolean = false;
    public tenantId: number = 0;
    public enterpriseId: number = 0;


    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }

    public callMethod(methodName): void {
        if (methodName === 'backToStoreEdit') {
            this.$router
                .push({
                    name: 'admin.stores.edit',
                    params: { id: this.vm.storeId.toString(), tab: 'VehicleWholesale' },
                })
                .catch((ex) => {
                    console.log(ex);
                });
        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(false, this.$t('cenposAccounts.alertFormInvalid'));
                this.resetMethodName(methodName);
                return;
            }
            this.submitVehicleWholeSaleAccount();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({
            id: '0',
            type: 'button',
            title: this.$parent.$t('stores.btnBackToStoreTitle'),
            disabled: false,
            visible: true,
            class: 'btn',
            label: this.$parent.$t('stores.btnBack'),
            click: 'backToStoreEdit',
            icon: 'fas fa-arrow-left',
        });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setFields();
        this.vm.storeId = Number(this.$route.params.storeId);

        this.vehicleWholeSaleAccountFormModel.saleAccount = this.$route.params.saleAccount;
        this.vehicleWholeSaleAccountFormModel.saleType = this.$route.params.saleType;
        this.vehicleWholeSaleAccountFormModel.costOfSaleAccount = this.$route.params.costOfSaleAccount;
        this.currentvehicleWholeSaleAccountId = this.$route.params.id;

    }
    public currentvehicleWholeSaleAccountId: string;
    public vehicleWholeSaleAccountFormModel = {

        saleType: '',
        saleAccount: '',
        costOfSaleAccount: ''
    };
    public setFields(): void {
        this.formFields = [

            {
                key: 'saleType',
                required: true,
                type: 'v-alynk-text-field',
                templateOptions: {
                    counter: 100,
                    label: 'SaleType',
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('SaleType', v)
                    ]
                },
            },
            {
                key: 'saleAccount',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 9,
                    label: 'SaleAccount',
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('SaleAccount', v)
                    ]
                },
            },
            {
                key: 'costOfSaleAccount',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 9,
                    label: 'Cost Of SaleAccount',
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('Cost Of SaleAccount', v)
                    ]
                },
            },

        ];
    }

    public validateVehicleWholeSaleAccountForm(): Vue & { validate: () => boolean } {
        return this.$refs.vehicleWholeSaleAccountForm as Vue & { validate: () => boolean };
    }

    public async submitVehicleWholeSaleAccount(): Promise<void> {
        if (this.validateVehicleWholeSaleAccountForm().validate()) {
            try {
                this.disableSubmitButton = true;
                this.$emit('update:progress', this.disableSubmitButton);
                this.formlyShowSkeleton(this.formFields);
                if (this.currentvehicleWholeSaleAccountId) {

                    await storeService.editVehicleSaleAccountSetupJson(
                        this.currentvehicleWholeSaleAccountId,
                        this.vehicleWholeSaleAccountFormModel.saleType,
                        this.vehicleWholeSaleAccountFormModel.saleAccount,
                        this.vehicleWholeSaleAccountFormModel.costOfSaleAccount,
                        this.vm.storeId
                    );
                    this.showAlert(true, 'Vehicle WholeSale Account Updated');
                } else {

                    await storeService.addVehicleSaleAccountSetupJson(
                        this.vm.storeId,
                        this.vehicleWholeSaleAccountFormModel.saleType,
                        this.vehicleWholeSaleAccountFormModel.saleAccount,
                        this.vehicleWholeSaleAccountFormModel.costOfSaleAccount
                    );
                    this.showAlert(true, 'Vehicle WholeSale Account Added');


                }
                this.formlyHideSkeleton(this.formFields);
                this.$router.push({
                    name: 'admin.stores.edit',
                    params: {
                        tenantId: this.tenantId.toString(),
                        enterpriseId: this.enterpriseId.toString(),
                        storeId: this.vm.storeId.toString(),
                        tab: 'VehicleWholesale'
                    },
                });

            } finally {

                this.disableSubmitButton = false;
                this.$emit('update:progress', this.disableSubmitButton);
            }
        }
    }


}
